import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LiveTicker from "./LiveTicker";
import WhatsAppFab from "./WhatsAppFab";

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="bg-[#0a1628] min-h-screen text-white">
      <Navbar />
      <LiveTickerWrapper />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

function LiveTickerWrapper() {
  return (
    <div className="fixed top-[78px] left-0 right-0 z-40">
      <LiveTicker />
    </div>
  );
}
